import React, { useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Divider,
  Card,
  CardContent,
  Alert,
  Snackbar,
  Tabs,
  Tab,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import {
  Settings as SettingsIcon,
  Store,
  Email,
  Payment,
  Security,
  Notifications,
  Language,
  Save,
} from '@mui/icons-material';
import settingsService from '../services/settingsService';

const TabPanel = ({ children, value, index }) => (
  <div hidden={value !== index}>
    {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
  </div>
);

const Settings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [settings, setSettings] = useState({
        // General Settings
        storeName: 'Khizly',
        storeEmail: 'xaintroadmin@gmail.com',
        storePhone: '+92 3347618394',
        storeAddress: '123 Main Street, Karachi, Pakistan',
        facebookLink: '',
        twitterLink: '',
        instagramLink: '',
        linkedinLink: '',
        currency: 'PKR',
        timezone: 'Asia/Karachi',
        language: 'en',

        // Email Settings
        emailEnabled: true,
        smtpHost: 'smtp.gmail.com',
        smtpPort: 587,
        smtpUser: '',
        smtpPassword: '',

        // Payment Settings
        paymentEnabled: true,
        cashOnDelivery: true,
        payfastEnabled: false,
        bankAlfalahEnabled: false,

        // Notification Settings
        orderNotifications: true,
        emailNotifications: true,
        smsNotifications: false,

        // Security Settings
        twoFactorAuth: false,
        sessionTimeout: 30,
        passwordMinLength: 8,
    });

  const handleChange = (field, value) => {
    setSettings((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const [isLoading, setIsLoading] = useState(false);

  React.useEffect(() => {
    const fetchSettings = async () => {
      try {
        setIsLoading(true);
        const data = await settingsService.getSettings();
        if (data) {
          setSettings(prev => ({
            ...prev,
            ...data
          }));
        }
      } catch (error) {
        console.error('Failed to fetch settings:', error);
        setSnackbar({
          open: true,
          message: 'Failed to load settings',
          severity: 'error',
        });
      } finally {
        setIsLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    try {
      setIsLoading(true);
      await settingsService.updateSettings(settings);
      setSnackbar({
        open: true,
        message: 'Settings saved successfully!',
        severity: 'success',
      });
    } catch (error) {
      console.error('Failed to save settings:', error);
      setSnackbar({
        open: true,
        message: 'Failed to save settings: ' + (error.response?.data?.message || error.message),
        severity: 'error',
      });
    } finally {
      setIsLoading(false);
    }
  };



  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Box>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          color: '#000000',
          fontWeight: 700,
          pb: 2,
          mb: 3,
          borderBottom: '2px solid #ff2852',
        }}
      >
        Settings
      </Typography>

      <Paper sx={{
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      }}>
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{
            borderBottom: '1px solid #e0e0e0',
            '& .MuiTab-root': {
              color: '#666666',
              fontWeight: 500,
              '&.Mui-selected': {
                color: '#ff2852',
                fontWeight: 600,
              },
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#ff2852',
            },
          }}
        >
          <Tab icon={<Store />} iconPosition="start" label="General" />
          <Tab icon={<Email />} iconPosition="start" label="Email" />
          <Tab icon={<Payment />} iconPosition="start" label="Payment" />
          <Tab icon={<Notifications />} iconPosition="start" label="Notifications" />
          <Tab icon={<Security />} iconPosition="start" label="Security" />
        </Tabs>

        {/* General Settings */}
        <TabPanel value={activeTab} index={0}>
          <Card sx={{
            backgroundColor: '#ffffff',
            border: 'none',
            boxShadow: 'none',
          }}>
            <CardContent>
              <Typography variant="h6" sx={{ color: '#000000', fontWeight: 700, mb: 3 }}>
                General Settings
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Store Name"
                    value={settings.storeName}
                    onChange={(e) => handleChange('storeName', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Store Email"
                    type="email"
                    value={settings.storeEmail}
                    onChange={(e) => handleChange('storeEmail', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Store Phone"
                    value={settings.storePhone}
                    onChange={(e) => handleChange('storePhone', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Currency</InputLabel>
                    <Select
                      value={settings.currency}
                      onChange={(e) => handleChange('currency', e.target.value)}
                      label="Currency"
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#ff2852',
                        },
                      }}
                    >
                      <MenuItem value="PKR">PKR - Pakistani Rupee</MenuItem>
                      <MenuItem value="USD">USD - US Dollar</MenuItem>
                      <MenuItem value="EUR">EUR - Euro</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Timezone</InputLabel>
                    <Select
                      value={settings.timezone}
                      onChange={(e) => handleChange('timezone', e.target.value)}
                      label="Timezone"
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#ff2852',
                        },
                      }}
                    >
                      <MenuItem value="Asia/Karachi">Asia/Karachi (PKT)</MenuItem>
                      <MenuItem value="UTC">UTC</MenuItem>
                      <MenuItem value="America/New_York">America/New_York (EST)</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <InputLabel>Language</InputLabel>
                    <Select
                      value={settings.language}
                      onChange={(e) => handleChange('language', e.target.value)}
                      label="Language"
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#ff2852',
                        },
                      }}
                    >
                      <MenuItem value="en">English</MenuItem>
                      <MenuItem value="ur">Urdu</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Store Address"
                    value={settings.storeAddress}
                    onChange={(e) => handleChange('storeAddress', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Facebook Link"
                    value={settings.facebookLink}
                    onChange={(e) => handleChange('facebookLink', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Twitter/X Link"
                    value={settings.twitterLink}
                    onChange={(e) => handleChange('twitterLink', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Instagram Link"
                    value={settings.instagramLink}
                    onChange={(e) => handleChange('instagramLink', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="LinkedIn Link"
                    value={settings.linkedinLink}
                    onChange={(e) => handleChange('linkedinLink', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>

        {/* Email Settings */}
        <TabPanel value={activeTab} index={1}>
          <Card sx={{
            backgroundColor: '#ffffff',
            border: 'none',
            boxShadow: 'none',
          }}>
            <CardContent>
              <Typography variant="h6" sx={{ color: '#000000', fontWeight: 700, mb: 3 }}>
                Email Settings
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={settings.emailEnabled}
                        onChange={(e) => handleChange('emailEnabled', e.target.checked)}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#ff2852',
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#ff2852',
                          },
                        }}
                      />
                    }
                    label="Enable Email Notifications"
                  />
                </Grid>
                {settings.emailEnabled && (
                  <>
                    {(!settings.smtpUser || !settings.smtpPassword) && (
                      <Grid item xs={12}>
                        <Alert
                          severity="info"
                          sx={{
                            mb: 2,
                            backgroundColor: '#e3f2fd',
                            '& .MuiAlert-icon': {
                              color: '#1976d2'
                            }
                          }}
                        >
                          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
                            SMTP Configuration Required
                          </Typography>
                          <Typography variant="body2">
                            To send subscription confirmation emails, please configure your SMTP settings below.
                            <br />
                            <strong>For Gmail:</strong> Use your Gmail address as SMTP Username and an App Password (not your regular password) as SMTP Password.
                            <br />
                            <strong>For other providers:</strong> Check your email provider's SMTP settings documentation.
                          </Typography>
                        </Alert>
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="SMTP Host"
                        value={settings.smtpHost}
                        onChange={(e) => handleChange('smtpHost', e.target.value)}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: '#e0e0e0',
                            },
                            '&:hover fieldset': {
                              borderColor: '#ff2852',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#ff2852',
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="SMTP Port"
                        type="number"
                        value={settings.smtpPort}
                        onChange={(e) => handleChange('smtpPort', e.target.value)}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: '#e0e0e0',
                            },
                            '&:hover fieldset': {
                              borderColor: '#ff2852',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#ff2852',
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="SMTP Username"
                        value={settings.smtpUser}
                        onChange={(e) => handleChange('smtpUser', e.target.value)}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: '#e0e0e0',
                            },
                            '&:hover fieldset': {
                              borderColor: '#ff2852',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#ff2852',
                            },
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        fullWidth
                        label="SMTP Password"
                        type="password"
                        value={settings.smtpPassword}
                        onChange={(e) => handleChange('smtpPassword', e.target.value)}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                              borderColor: '#e0e0e0',
                            },
                            '&:hover fieldset': {
                              borderColor: '#ff2852',
                            },
                            '&.Mui-focused fieldset': {
                              borderColor: '#ff2852',
                            },
                          },
                        }}
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>

        {/* Payment Settings */}
        <TabPanel value={activeTab} index={2}>
          <Card sx={{
            backgroundColor: '#ffffff',
            border: 'none',
            boxShadow: 'none',
          }}>
            <CardContent>
              <Typography variant="h6" sx={{ color: '#000000', fontWeight: 700, mb: 3 }}>
                Payment Settings
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={settings.paymentEnabled}
                        onChange={(e) => handleChange('paymentEnabled', e.target.checked)}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#ff2852',
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#ff2852',
                          },
                        }}
                      />
                    }
                    label="Enable Payment Processing"
                  />
                </Grid>
                {settings.paymentEnabled && (
                  <>
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.cashOnDelivery}
                            onChange={(e) => handleChange('cashOnDelivery', e.target.checked)}
                            sx={{
                              '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#ff2852',
                              },
                              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#ff2852',
                              },
                            }}
                          />
                        }
                        label="Cash on Delivery"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.payfastEnabled}
                            onChange={(e) => handleChange('payfastEnabled', e.target.checked)}
                            sx={{
                              '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#ff2852',
                              },
                              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#ff2852',
                              },
                            }}
                          />
                        }
                        label="PayFast Payment Gateway"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={settings.bankAlfalahEnabled}
                            onChange={(e) => handleChange('bankAlfalahEnabled', e.target.checked)}
                            sx={{
                              '& .MuiSwitch-switchBase.Mui-checked': {
                                color: '#ff2852',
                              },
                              '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#ff2852',
                              },
                            }}
                          />
                        }
                        label="Bank Alfalah Payment Gateway"
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>

        {/* Notification Settings */}
        <TabPanel value={activeTab} index={3}>
          <Card sx={{
            backgroundColor: '#ffffff',
            border: 'none',
            boxShadow: 'none',
          }}>
            <CardContent>
              <Typography variant="h6" sx={{ color: '#000000', fontWeight: 700, mb: 3 }}>
                Notification Settings
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={settings.orderNotifications}
                        onChange={(e) => handleChange('orderNotifications', e.target.checked)}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#ff2852',
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#ff2852',
                          },
                        }}
                      />
                    }
                    label="Order Notifications"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={settings.emailNotifications}
                        onChange={(e) => handleChange('emailNotifications', e.target.checked)}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#ff2852',
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#ff2852',
                          },
                        }}
                      />
                    }
                    label="Email Notifications"
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={settings.smsNotifications}
                        onChange={(e) => handleChange('smsNotifications', e.target.checked)}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#ff2852',
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#ff2852',
                          },
                        }}
                      />
                    }
                    label="SMS Notifications"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>

        {/* Security Settings */}
        <TabPanel value={activeTab} index={4}>
          <Card sx={{
            backgroundColor: '#ffffff',
            border: 'none',
            boxShadow: 'none',
          }}>
            <CardContent>
              <Typography variant="h6" sx={{ color: '#000000', fontWeight: 700, mb: 3 }}>
                Security Settings
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={settings.twoFactorAuth}
                        onChange={(e) => handleChange('twoFactorAuth', e.target.checked)}
                        sx={{
                          '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#ff2852',
                          },
                          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                            backgroundColor: '#ff2852',
                          },
                        }}
                      />
                    }
                    label="Two-Factor Authentication"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Session Timeout (minutes)"
                    type="number"
                    value={settings.sessionTimeout}
                    onChange={(e) => handleChange('sessionTimeout', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Minimum Password Length"
                    type="number"
                    value={settings.passwordMinLength}
                    onChange={(e) => handleChange('passwordMinLength', e.target.value)}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#e0e0e0',
                        },
                        '&:hover fieldset': {
                          borderColor: '#ff2852',
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#ff2852',
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </TabPanel>

        <Divider sx={{ my: 2 }} />
        <Box sx={{ p: 2, display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            startIcon={<Save />}
            onClick={handleSave}
            sx={{
              backgroundColor: '#ff2852',
              color: 'white',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#5A189A',
              },
            }}
          >
            Save Settings
          </Button>
        </Box>
      </Paper>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Settings;
